var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgK12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.033 5.337c-.3-.033-.633-.033-1-.033-2.7.1-4.4 1.6-4.767 1.967-.4-.367-2.1-1.867-4.766-1.967-3.034-.1-5 1.667-5.333 1.967v14.733c2.966-1.167 7.6-2 11.566-.133 2.867-1.367 5.9-1.467 8.667-.7V7.27c-.3-.267-1.9-1.7-4.367-1.934z",
    fill: "#0C0A0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.834 19.704c-1-.4-2.567-.867-4.567-.967-2.5-.1-4.467.534-5.567.967V4.971c.4-.367 2.1-1.867 4.767-1.967 3.033-.1 5 1.667 5.333 1.967.034 4.933.034 9.833.034 14.733z",
    fill: "#A9F4F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.633 19.704c1-.4 2.567-.867 4.567-.967 2.5-.1 4.467.534 5.567.967V4.971c-.4-.367-2.1-1.867-4.767-1.967-3.033-.1-5 1.667-5.333 1.967-.034 4.933-.034 9.833-.034 14.733z",
    fill: "#A9F4F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.066 9.304c.6-.334 1.9-1 3.7-.967a7.49 7.49 0 013.5.967M4.066 11.838c.6-.334 1.9-1 3.7-.967a7.49 7.49 0 013.5.966M4.066 14.404c.6-.333 1.9-1 3.7-.967a7.49 7.49 0 013.5.967M4.066 16.937c.6-.333 1.9-1 3.7-.967a7.49 7.49 0 013.5.967M4.066 6.737c2.8-2.733 3.667 0 6.767 0M14.2 6.737c.6-.333 1.9-1 3.7-.966a7.49 7.49 0 013.5.966M14.2 9.304c.6-.333 1.9-1 3.7-.966a7.49 7.49 0 013.5.966M14.2 11.838c.6-.334 1.9-1 3.7-.967a7.49 7.49 0 013.5.966M14.2 14.404c.6-.333 1.9-1 3.7-.967a7.49 7.49 0 013.5.967M12.733 5.137v14.4M22.667 17.038c-.8-.067-1.6-.3-2.367-.634 0 1.1-.033 1.834-.333 2.367",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgK12;